import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  formFields: {},
}

const createFormFieldsSlice = createSlice({
  name: 'createPayload',
  initialState,
  reducers: {
    // Update Payload
    createPayload: (state, action) => {
      state.formFields = {
        ...state.formFields,
        ...action.payload,
      }
    },
  },
})

export const { createPayload } = createFormFieldsSlice.actions

export default createFormFieldsSlice.reducer
